import DOMPurify from 'dompurify';

export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['style', 'script'],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|ftp):|\/\/)/i,
    });
}
